import { ParamMap } from "@angular/router";
import { coerceBooleanProperty, coerceNumberProperty } from "@angular/cdk/coercion";
import moment from "moment";



export function parseSort(sort: string): { predicate: string, ascending: boolean } {
  let sortArray = sort.split(',');

  return {
    predicate: sortArray[0],
    ascending: sortArray.length === 1 || sortArray.slice(-1)[0] === 'asc',
  };
}

export function convertQueryParamMap(params: ParamMap, types: Record<string, App.FilterParamType>): Record<string, unknown> {
  const values: Record<string, unknown> = {};

  for (const key in types) {
    const type = types[key];

    switch (type) {
      case 'boolean':
        values[key] = coerceBooleanProperty(params.get(key));
        break;
      case 'date':
        values[key] = moment(params.get(key));
        break;
      case 'number':
        values[key] = coerceNumberProperty(params.get(key));
        break;
      case 'array_boolean':
        values[key] = params.getAll(key).map((item) => {
          return coerceBooleanProperty(item);
        });
        break;
      case 'array_date':
        values[key] = params.getAll(key).map((item) => {
          return moment(item);
        });
        break;
      case 'array_number':
        values[key] = params.getAll(key).map((item) => {
          return coerceNumberProperty(item);
        });
        break;
      case 'array_string':
        values[key] = params.getAll(key);
        break;
      default: // string
        values[key] = params.get(key);
    }
  }

  return values;
}
